import { render, staticRenderFns } from "./finantial-settings-payout-schedule-page.vue?vue&type=template&id=ba1385d6&scoped=true&"
import script from "./finantial-settings-payout-schedule-page.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-payout-schedule-page.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-payout-schedule-page.vue?vue&type=style&index=0&id=ba1385d6&lang=scss&scoped=true&"
import style1 from "./finantial-settings-payout-schedule-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1385d6",
  null
  
)

export default component.exports